import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

interface LoadingScreenProps {
  stage?: string;
  isHidden?: boolean;
  onLoadComplete?: () => void;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  stage = 'Loading...', 
  isHidden = false,
  onLoadComplete
}) => {
  const [dots, setDots] = useState('');
  
  // Animate the dots for a smooth loading effect
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => {
        if (prev === '...') return '';
        return prev + '.';
      });
    }, 500);
    
    return () => clearInterval(interval);
  }, []);

  // Simplified stage messages that are more user-friendly
  const getDisplayMessage = (stage: string) => {
    if (stage.includes('Initializing') || stage.includes('application')) {
      return 'Starting up';
    }
    if (stage.includes('zoning') || stage.includes('Toronto')) {
      return 'Loading zoning data';
    }
    if (stage.includes('map') || stage.includes('resources') || stage.includes('boundaries')) {
      return 'Preparing map';
    }
    if (stage.includes('Connecting') || stage.includes('services')) {
      return 'Connecting to services';
    }
    if (stage.includes('Finalizing') || stage.includes('setup')) {
      return 'Almost ready';
    }
    if (stage.includes('Ready')) {
      return 'Ready!';
    }
    return 'Loading';
  };

  return (
    <div className={`loading-screen ${isHidden ? 'hidden' : ''}`}>
      <div className="loading-content">
        <div className="logo-container">
          <img 
            src="/DES-20250328_Logo_v3_SS.png" 
            alt="ZoningPal Logo" 
            className="loading-logo"
          />
          
          <div className="brand-text">
            <h1>ZoningPal</h1>
            <p>AI-Powered Zoning Intelligence</p>
          </div>
        </div>
        
        <div className="loading-animation">
          <div className="loading-bars">
            <div className="loading-bar bar-1"></div>
            <div className="loading-bar bar-2"></div>
            <div className="loading-bar bar-3"></div>
            <div className="loading-bar bar-4"></div>
            <div className="loading-bar bar-5"></div>
          </div>
        </div>
        
        <div className="loading-status">
          <p>{getDisplayMessage(stage)}{dots}</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
